/** localStorage keys of unsaved prescriptions (see usePrescriptionDraft) */
export const RX_DRAFT_PREFIX = "rx-draft:";

/** On logout: drafts hold patient details and must not outlive the session on a shared computer */
export function clearPrescriptionDrafts() {
  try {
    Object.keys(localStorage).filter(k => k.startsWith(RX_DRAFT_PREFIX)).forEach(k => localStorage.removeItem(k));
  } catch { /* storage blocked */ }
}
